/** What the game's events mean for the music and for a screen reader (docs/spec/04 §5, §7). Pure. */

import type { MusicTrack } from '../../audio/types';
import type { SimEvent } from '../../sim';

/** The track an event starts (null: silence), or undefined to leave the music alone. */
export function musicCue(e: SimEvent): MusicTrack | null | undefined {
  switch (e.type) {
    case 'warning': return 'empress';
    case 'empressKilled': return null;
    case 'gameOver': return 'gameover';
    default: return undefined;
  }
}

/** Words for the live region, or '' for nothing. */
export function announcement(e: SimEvent): string {
  switch (e.type) {
    case 'stageStart':
      if (e.kind === 'challenge') return `Stage ${e.stage}. Challenging stage.`;
      if (e.kind === 'empress') return `Stage ${e.stage}. Warning: the Empress approaches.`;
      return `Stage ${e.stage}.`;
    case 'captured': return 'Fighter captured.';
    case 'rescued': return 'Fighter rescued.';
    case 'docked': return 'Dual fighter.';
    case 'playerDied': return e.survivor ? 'One fighter lost.' : 'Fighter destroyed.';
    case 'ready': return 'Ready.';
    case 'extraLife': return 'Bonus fighter.';
    case 'tally': return e.perfect ? `Perfect. Bonus ${e.bonus}.` : `${e.hits} hits. Bonus ${e.bonus}.`;
    case 'powerUp': return `${e.kind} capsule.`;
    case 'empressKilled': return 'The Empress is destroyed.';
    case 'gameOver': return 'Game over.';
    default: return '';
  }
}
